<div class="change-entity-container">
  <img
    src="assets/icons/forward-arrow.svg"
    alt="Changer l'entité"
    class="change-entity-container-icon"
    [class.disabled]="isDisabled"
    (click)="onChangeEntityClick($event)"
    style="width: 25px; height: 25px"
  />
</div>
